"use client"
import "./benefit-bar.css"
import HookSvg from "@/assets/icons/hook.svg";
import React, { useEffect, useState, lazy, Suspense } from "react";
import(/* webpackPrefetch: true */ "./benefitDialog");

const BenefitDialog = lazy(() => import("./benefitDialog"));

const BenefitBarClient = ({ mindList }) => {

  const [isOpen, setIsOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");

  const initMindTransition = () => {
    const container = document.getElementById("jdi-header-scroll-benefit-wrap");
    const tags = Array.from(container.querySelectorAll(".tag"));

    const firstClone = tags[0].cloneNode(true);
    container.appendChild(firstClone);

    let currentIndex = 0;

    function scrollTags() {
      currentIndex++;

      container.style.transition = "transform 0.5s ease";
      container.style.transform = `translateY(${-currentIndex * tags[0].offsetHeight}px)`;

      if (currentIndex === tags.length) {
        setTimeout(() => {
          container.style.transition = "none";
          container.style.transform = "translateY(0)";
          currentIndex = 0;
        }, 500);
      }
    }

    return setInterval(scrollTags, 5000);
  };

  useEffect(() => {
    let intervalId;
    if (mindList && mindList.length > 2) {
      intervalId = initMindTransition();
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [mindList]);

  const handleOpenServiceDialog = (mindObj) => {
    setIsOpen(true);
    setTitle(mindObj.serviceTitle);
    setContent(mindObj.serviceContent);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const getBenefit = (mindObj) => {
    return (
      <div className="tag" onClick={() => handleOpenServiceDialog(mindObj)}>
        <HookSvg />
        <div className="txt">
          <div className="title bold-weight">{mindObj.serviceTitle}</div>
          <div className="sub-title">{mindObj.serviceSubTitle}</div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="tag-wrap">{mindList && mindList.length ? getBenefit(mindList[0]) : null}</div>
      <div className="tag-wrap">
        <div className="tags-wrap">
          <div className="tags" id="jdi-header-scroll-benefit-wrap">
            {mindList && mindList.length > 1
              ? mindList.slice(1).map((item) => <React.Fragment key={item.serviceTitle}>{getBenefit(item)}</React.Fragment>)
              : null}
          </div>
        </div>
      </div>
      {isOpen && (
        <Suspense fallback={null}>
          <BenefitDialog open={isOpen} title={title} content={content} closeFn={handleClose} />
        </Suspense>
      )}
    </>
  );
};

export default BenefitBarClient;
